import { IonContent, IonIcon, IonPage } from "@ionic/react";
import { Button, Typography } from "@material-ui/core";
import React from "react";
import { checkmarkCircleOutline, closeOutline } from "ionicons/icons";
import Header from "src/components/Header";
import { withRouter } from "react-router";
import { PageProps } from "src/utils";

const ReclamoSolicitudExito: React.FC<PageProps> = ({ location, history }) => {
  // esta pagina necesita un query param "from" que indique
  // la ruta de la pagina previa a la pagina del detalle que llamo a esta vista
  const params = location.search.split("&");
  const accion = params[0].split("?accion=")[1];
  const pageFrom = params[1].split("pageTo=")[1];

  const handleClick = () => {
    volverALaListaPrevia();
  };

  const volverALaListaPrevia = () => {
    history.push(pageFrom);
  };

  const botonCerrar = {
    icono: closeOutline,
    action: volverALaListaPrevia,
  };

  const iconStyle = {
    color: "#910434",
    fontSize: "125px",
  };

  return (
    <IonPage>
      <Header titulo="Reclamo enviado" botonIzq={botonCerrar} />

      <IonContent>
        <div className="d-flex flex-column equal-size-children h-100">
          <div className="d-flex flex-centered-content h-100 w-100">
            <div className="logo d-flex flex-column flex-centered-content">
              <IonIcon
                icon={checkmarkCircleOutline}
                style={iconStyle}
              ></IonIcon>
              <Typography className="text-center" variant="h6">
                {crearTitulo(accion)}
              </Typography>
            </div>
          </div>
          <div className="d-flex flex-column justify-content-start align-items-center">
            <Typography className="text-center width-logo mb-2" variant="body2">
              {crearCuerpo(accion)}
            </Typography>

            <Button
              className="button"
              variant="contained"
              color="primary"
              onClick={handleClick}
            >
              ACEPTAR
            </Button>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(ReclamoSolicitudExito);

function crearTitulo(accion: string) {
  switch (accion) {
    case "crear":
      return "Reclamo creado exitosamente";

    case "aceptar":
      return "Reclamo aceptado exitosamente";

    default:
      return "Reclamo rechazado exitosamente";
  }
}

function crearCuerpo(accion: string) {
  switch (accion) {
    case "crear":
      return "Nos comunicaremos contigo cuando gestionemos tu reclamo.";

    default:
      return "Gracias por actualizar la marcación";
  }
}
